<template>
  <div class="left-nav">
 
    <ul id="left-menu">
      <li v-for="item in menuNavList" :key="item.link" :class="cls( item.link)">
        <router-link :to="item.link" > 
          <svg-icon :name="item.icon" size="32"></svg-icon>
          <span class="icon-name">{{ item.label }}</span>
        </router-link>
      </li>
    </ul>
  </div>
</template>
<script>
import Permissions from "../../store/permissions.js";
import { mapGetters, mapMutations } from "vuex";
export default {
  data() {
    return {
      isCollapse: true,
      username: null,
      menuNav: [
        { label: "首页", icon: "home", link: "index" },
        { label: "装备研究", icon: "wheel", link: "equipanalysis" },
        { label: "销量研究", icon: "price", link: "saleanalysis" },
        { label: "模型研究", icon: "model", link: "modeltimeline" },
          { label: "MADE价格指数", icon: "gain", link: "gain" }
      ],
    };
  },
  methods: {
    ...mapMutations(["setLeftCollapse"]),
    async toggleCollapse() {
      //  alert(this.check.Client_ViewSales_Model_Down());

      this.isCollapse = !this.isCollapse;
      this.setLeftCollapse(this.isCollapse);
    },
     cls(name){
       let rn = this.$route.name ;
        
       console.log("rn="+rn);
      if( name=="index")
      {
         return name ==rn? "current":""; 
      }else if(name=="equipanalysis")
      {
        if(rn=="equippk4" || rn=="equippk4"){
          return "current";
        }
        if( this.equipMenu.findIndex(item=>{return item.link.indexOf(rn)>=0})>=0)
        {
          return "current";
        }
      }else if(name=="saleanalysis")
      {

        
        if(rn=="flexmonster" )
        {
           var t = this.$route.query.datatype;
           if(t!="gain"){
              return "current";
           }
         
        }
        if( this.saleMenu.findIndex(item=>{return item.link.indexOf(rn)>=0})>=0)
        {
          return "current";
        }
      }else if(name=="modeltimeline")
      {
        if( this.modelMenu.findIndex(item=>{return item.link.indexOf(rn)>=0})>=0)
        {
          return "current";
        }
      }else if(name=="gain")
      {
         if(rn=="gaincharts")
         {
           return "current";
         }
         if(rn=="flexmonster")
        {
           var t = this.$route.query.datatype;
           if(t=="gain"){
              return "current";
           }
        }
      
        if( this.gainMenu.findIndex(item=>{return item.link.indexOf(rn)>=0})>=0)
        {
          return "current";
        }
      }
      return "";
    },
  },
  created() {},
  computed: {
    ...mapGetters("user", ["currentLoginInfo", "userConfig", "token"]),
    toggleIcon() {
      return this.isCollapse ? "el-icon-menu" : "el-icon-menu";
    },
    checkfunc() {
      return this.checkPermission();
    },
    showIndexPage() {
      return true;
    },
    check() {
      return Permissions;
    },
    menuNavList(){
        var ls = [];
        for(let x of this.menuNav)
        {
           if(x.label=="首页")
           {
                 ls.push(x);
           }
           else if(x.label=="装备研究")
           {
              if(Permissions.client_view_nav_equip()){
                 ls.push(x);
              }
           }
            else if(x.label=="销量研究")
           {
               if(Permissions.client_view_nav_sale()){
                ls.push(x);
               }
              
           }else if(x.label=="模型研究")
           {
               if(Permissions.client_view_nav_depth()){
                ls.push(x);
               }
                 
           }
           else if(x.label=="MADE价格指数")
           {
               
               if(Permissions.client_view_made())
               {
                 ls.push(x);
               }
                
              
                 
           }
        }
        console.log(ls);
        return ls;
    },
    showChartMgr() {
      return (
        this.username == "wangshengwei" ||
        this.username == "zhuliang" ||
        this.username == "admin"
      );
    },
  },
  watch: {
    currentLoginInfo(newValue) {
      this.username = newValue.user.name;
    },
  },
};
</script>
<style>
.left-nav {
  width: 120px;
  position: absolute;
  bottom: 0;
  top: 62px;
  margin-left: -1px;
  height: 100vh;
  z-index: 10000;
  text-align: left;

  background-color: #fff;
  color: #7c899b;
  z-index: 184;
  /*border-right: 1px solid rgba(0, 0, 0, 0.1);*/
  box-shadow: 1px 1px 1px 0px rgba(0, 0, 0, 0.1);
   min-height:650px;
}
#left-menu {
  overflow: hidden;
  list-style: none;
  padding: 0 !important;
  /*border: 1px solid #eaeefb;*/
  border-radius: 4px;
}
#left-menu li {
  display: list-item;
  text-align: -webkit-match-parent;

  text-align: center;
  height: 120px;
  line-height: 120px;
  color: #666;
  font-size: 13px;
  /*border-right: 1px solid #eee;
    border-bottom: 1px solid #eee;*/
  margin-right: -1px;
  margin-bottom: -1px;
}
#left-menu li a {
  line-height: normal;
  color: #99a9bf;
  transition: color 0.15s linear;
}
#left-menu li:after,
#left-menu li a {
  display: inline-block;
  vertical-align: middle;
}
#left-menu li svg {
  display: block;
  font-size: 32px;
  margin: 0 auto 5px auto;
  color: #606266;
  transition: color 0.15s linear;
}
#left-menu li .icon-name {
  display: inline-block;
  padding: 0 3px;
  height: 1em;
  text-align: center;
}
#left-menu li.current a,
#left-menu li.current a svg,
#left-menu li.current a span {
  color: #3284d7 !important;
}
a:hover  svg,
a:hover span {
  color: #ffad53 !important;
}


.avatar {
  display: inline-block;
  text-align: center;
  background: #ccc;
  color: #fff;
  white-space: nowrap;
  position: relative;
  overflow: hidden;
  vertical-align: middle;
  width: 32px;
  height: 32px;
  line-height: 32px;
  border-radius: 16px;
}
.avatar img {
  width: 100%;
  height: 100%;
}
</style>

